module.exports = __webpack_public_path__ + "static/media/bg-menu.3e7e63a0.jpg";